import { z } from 'zod';

export const bookingSchema = z.object({
  id: z.number(),
  status: z.string(),
  requested_seats: z.number(),
  customer_first_name: z.string().optional().nullable(),
  customer_last_name: z.string().optional().nullable(),
  passenger_status: z.string(),
  action: z.string(),

  // unused
  ride: z.number(),
  comment: z.string(),
  customer: z.number().optional().nullable(),
  pickup_time: z.string().optional().nullable(),
  dropoff_time: z.string().optional().nullable(),
  pickup_walking_time: z.number().optional().nullable(),
  dropoff_walking_time: z.number().optional().nullable(),

  // legacy
  // confirmed_pickup_time: z.string().nullable().optional().nullable(),
  // pickup_stop_name: z.string().optional().nullable(),
  // dropoff_stop_name: z.string().optional().nullable(),
  // min_estimated_time_at_pickup: z.string().optional().nullable(),
  // max_estimated_time_at_dropoff: z.string().optional().nullable(),
  // pickup_node: z.number().optional().nullable(),
  // dropoff_node: z.number().optional().nullable(),
});

export type Booking = z.infer<typeof bookingSchema>;
